module.exports = __webpack_public_path__ + "img/supplier-basic-vip-bg.a0253786.png";